export default __webpack_public_path__ + "static/jumbotron-bg-66c40ef274e7e339805f779ea6198120.png";